<template>
  <div class="special-main">
    <div class="special-body">
      <div class="banner-container" ref="bannerContainerRef">
        <div class="banner" ref="bannerRef">
          <div class="banner-logo">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260111/b2854b2be4cd927e35478aa0f52897b8.jpg" alt="">
          </div>
          <p class="banner-title">
            The Future of Endodontics
          </p>
          <div class="banner-product">
            <img @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/e56fe44960d9a0ba6e466d8e052f3c4c.png" alt="">
          </div>
          <!--          <img  @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251213/c6a240bdcae136014d3cc484e3d404b0.jpg" alt="">-->
        </div>
        <div class="preview-video-container" ref="previewVideoContainerRef">
          <div class="preview-video-box" ref="previewVideoBoxRef">
          </div>
          <div class="preview-video-text" ref="previewVideoTextRef">
            <h4>TorqueSense™: Real-Time Torque Control</h4>
            <h4>ClearSignal™: Signal Quality Indicator</h4>
            <h4>Customizable "Build-Your-File" Feature</h4>
            <h4>Cordless Freedom & HD Touchscreen</h4>
            <endo-button @onclick="openVideoModal(videoList[0].previewVideo)"></endo-button>
          </div>
          <div class="progress">
            <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
          </div>
          <video class="background-video"
                 :ref="videoList[0].ref"
                 :src="videoList[0].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>
      </div>

      <div class="section-product-desc">
        <div class="product-logo">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/87e903851c3d897212cbc769f7cbf820.png" alt="">
        </div>
        <div class="product-logo-text">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/67e1d823677d4b4c5aff4dcee4305af0.png" alt="">
        </div>
        <div class="product-image">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/53bcd6f9b799a2382480c45080755cbe.png" alt="">
        </div>
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>A real-time intelligent</h5>
            <h5>torque setting</h5>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>
        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">Woodpecker has introduced an innovative system for real-time torque determination</p>
          <p class="txt">that analyzes the cutting resistance of files against the dentin wall. The Endo GT</p>
          <p class="txt">Series learns the torque needed to cut through dentin and automatically</p>
          <p class="txt">adjusts to set the ideal torque for each section of the canal. This ensures</p>
          <p class="txt">that cutting power is tailored to the task while protecting against</p>
          <p class="txt">torsional fatigue and file separation.</p>
          <endo-button @onclick="openVideoModal(videoList[1].previewVideo)"></endo-button>
        </div>

        <div class="product-video-container">
          <div class="progress">
            <circular-progress :progress="videoList[1].progress" :isPlaying="videoList[1].playing" index="1" @togglePlay="togglePlay"/>
          </div>
          <video class="product-video"
                 :ref="videoList[1].ref"
                 :src="videoList[1].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>

        <div class="product-detail-text1 product-detail-text2">
          <p class="txt">The motor detects torque in real time and establishes the ideal safety threshold based on
            the file's cutting surface area.</p>
          <p class="txt">The proprietary technology automatically switches to a safe right-cutting reciprocating
            mode when torque exceeds the set threshold.</p>
          <p class="txt">There is no need to pre-set torque values for different files.</p>
        </div>

        <div class="step-list">
          <div class="step-item">
            <video class="step-video-1"
                   :ref="videoList[2].ref"
                   :src="videoList[2].video"
                   muted
                   playsinline
                   loop
            ></video>
            <div class="step-video-txt">
              <div class="step-video-title">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">
                <h5>Step 1</h5>
              </div>
              <p class="txt-big mt-15">2<span class="txt-middle">s</span></p>
              <p class="txt-small">Learning</p>
              <p class="txt-small">torque</p>
            </div>
          </div>
          <div class="step-item">
            <video class="step-video-2"
                   :ref="videoList[3].ref"
                   :src="videoList[3].video"
                   muted
                   playsinline
                   loop
            ></video>
            <div class="step-video-txt">
              <div class="step-video-title">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">
                <h5>Step 2</h5>
              </div>
              <p class="txt-small mt-25">Auto-set</p>
              <p class="txt-small">the ideal</p>
              <p class="txt-small">torque</p>
            </div>
          </div>
          <div class="step-item">
            <video class="step-video-3"
                   :ref="videoList[4].ref"
                   :src="videoList[4].video"
                   muted
                   playsinline
                   loop
            ></video>
            <div class="step-video-txt">
              <div class="step-video-title">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">
                <h5>Step 3</h5>
              </div>
              <p class="txt-small mt-25">Reciprocation</p>
              <p class="txt-small">if torque is</p>
              <p class="txt-small">surpassed</p>
            </div>
          </div>
        </div>
      </div>

      <div class="section-product-suit section-product-desc">
        <div class="product-logo">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/fd75dc0a2eb9cc522f4458e6482640d0.png" alt="">
        </div>
        <div class="product-logo-text">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/ef9dacf873710fd3a4777acd9297cc29.png" alt="">
        </div>
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>A powerful aid for electronic</h5>
            <h5>readings accuracy</h5>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>

        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">Unstable or inconsistent electronic measurements can lead to inaccurate readings.</p>
          <p class="txt">ClearSignal™ technology evaluates the strength of the electronic signal,</p>
          <p class="txt">helping determine whether the connection is reliable for accurately</p>
          <p class="txt">locating the foramen exit.</p>
          <endo-button @onclick="openVideoModal(videoList[5].previewVideo)"></endo-button>
        </div>

        <div class="g-preview-video-container product-video-container">
          <div class="progress">
            <circular-progress :progress="videoList[5].progress" :isPlaying="videoList[5].playing" index="5" @togglePlay="togglePlay"/>
          </div>
          <video class="g-preview-video product-video"
                 :ref="videoList[5].ref"
                 :src="videoList[5].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>

        <div class="product-detail-text1 product-detail-text2 product-detail-text3">
          <p class="txt">Displays real-time electronic signal strength</p>
          <p class="txt">Taps the center dial for instant on-screen alerts and guidance</p>
        </div>

        <div class="g-mode-video-container product-video-container">
          <video class="g-mode-video product-video"
                 :ref="videoList[6].ref"
                 :src="videoList[6].video"
                 muted
                 playsinline
                 loop
                 @canplaythrough="onModeVideoLoaded"
          ></video>
        </div>
      </div>

      <div class="improved-container" ref="improvedContainerRef">
        <div class="improved-banner">
          <img @load="onImprovedBanner" :style="{top: -improvedBannerTop + 'px'}" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260118/aee5559d4caf2d8c114ba48a292657b5.jpg" alt="">
          <div class="blur-after"></div>
          <div class="improved-background"></div>
          <div class="improved-banner-text">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <h5>Improved</h5>
                <h5>handpiece</h5>
                <h5>response</h5>
              </div>
              <div class="product-special-title-p">
                <p>The Endo GT Series leads the way</p>
                <p>with advanced handpiece control</p>
                <p>technology, ensuring reciprocation</p>
                <p>angles align precisely with today's</p>
                <p>diverse file specifications.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="improved-content" ref="improvedContentRef">
          <div class="improved-content-container">
            <div class="improved-content-title-info">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>Multiple protections</h5>
                  <h5>for safer and more</h5>
                  <h5>controlled canal preparation</h5>
                </div>
              </div>
            </div>
            <div class="improved-content-detail">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>Apex-driven monitoring system</h5>
                </div>
                <div class="product-special-title-p">
                  <p>Sync audio-visual feedback: The audible alarm gradually intensifies as the file approaches</p>
                  <p>the apical alarm, and emits a continuous tone with the LED flashing upon reaching it.</p>
                  <p>Dynamic progress tracking: On-screen apex indicator bar shows real-time file progress inside the canal.</p>
                </div>
              </div>
            </div>
            <div class="improved-content-detail">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>Intelligent preset control system</h5>
                </div>
                <div class="product-special-title-p">
                  <p>Auto Start/Stop: File starts and stops automatically as it enters or exits the canal.</p>
                  <p>Auto Slowdown: File slows down automatically as it approaches the apical alarm.</p>
                  <p>Auto Reverse/Stop: File reverses or stops rotation automatically upon reaching the apical alarm.</p>
                </div>
              </div>
            </div>
          </div>

          <!--          <div class="torque-sense">-->
          <!--            <div class="torque-sense-logo">-->
          <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/8da99d7895634c11c0388d0b4b68907a.png" alt="">-->
          <!--            </div>-->
          <!--            <div class="product-special-title">-->
          <!--              <div class="product-special-title-b">-->
          <!--                <h5>TorqueSense</h5>-->
          <!--              </div>-->
          <!--              <div class="product-special-title-p">-->
          <!--                <p>Effortless torque</p>-->
          <!--                <p>control with precise</p>-->
          <!--                <p>adjustments</p>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="atr-mode">-->
          <!--            <div class="atr-mode-logo">-->
          <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/173dba0a4e426292c168e6b19dcad79b.png" alt="">-->
          <!--            </div>-->
          <!--            <div class="product-special-title">-->
          <!--              <div class="product-special-title-b">-->
          <!--                <h5>ATR Mode</h5>-->
          <!--              </div>-->
          <!--              <div class="product-special-title-p">-->
          <!--                <p>Reciprocation is ignited</p>-->
          <!--                <p>when the torque is</p>-->
          <!--                <p>surpassedas a safety feature</p>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>

      <div class="contra-angle-container">
        <div class="contra-angle-banner">
          <div class="contra-angle-box">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260126/b6fae8e10d30f115833d98ad4ed608d9.png" alt=""/>
            <div class="product-special-title">
              <div class="bending-head">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260521/8b5ea166df15f2c848f661f9d0808993.jpg" alt="">
              </div>
              <div class="product-special-title-b">
                <h5>8 mm</h5>
                <h5>diameter</h5>
              </div>
              <div class="product-special-title-p">
                <p>Ultra-slim 8 mm head for superior access</p>
                <p>to posterior teeth</p>
              </div>
            </div>
          </div>
          <div class="contra-angle-banner-text">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <h5>Contra-angle</h5>
                <h5>head with</h5>
                <h5>LED light</h5>
              </div>
              <div class="flex contra-angle-parameter">
                <div class="bottom-align">
                  <div class="product-special-title-b">
                    <h5 style="vertical-align: bottom;">≥8000</h5>
                  </div>
                  <div class="product-special-title-p">
                    <p class="p-color">lux</p>
                  </div>
                </div>
                <!--                <div class="bottom-align">-->
                <!--                  <div class="product-special-title-b">-->
                <!--                    <h5>8 mm</h5>-->
                <!--                  </div>-->
                <!--                  <div class="product-special-title-p">-->
                <!--                    <p>diameter</p>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
              <div class="product-special-title-p contra-angle-desc">
                <p class="p-color">Adjustable cold light for shadow-free illumination</p>
              </div>
            </div>
          </div>
        </div>
        <div class="contra-angle-animation">
          <div class="contra-angle-slider">
            <i class="dark">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/791eea63527aa78c4a20687435031129.png" alt="">
            </i>
            <el-slider v-model="contraAngleSliderValue" :show-tooltip="false" :max="contraAngleBanner.length" @input="listenMove"></el-slider>
            <i class="light">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/234999d86aa2515b99003560dc84cb3e.png" alt="">
            </i>
          </div>
          <div class="contra-angle-animation-container">
            <img ref="contraAngleAnimationRef" :src="contraAngleBanner[0]" alt="">
          </div>
        </div>
      </div>

      <div class="section-build-file">
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>Build you file</h5>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>
        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">The Endo GT series enables users to build files and sequences using an intuitive,</p>
          <p class="txt">user-friendly interface. Create your file based on specifications such as tip, taper,</p>
          <p class="txt">color identification, and additional parameters. Generate a sequence of hybrid</p>
          <p class="txt">files using various brands from the library or those created by the operator.</p>
          <p class="txt">Develop distinct sequences for various scenarios, including</p>
          <p class="txt">glide path, MB2, large canals, and more.</p>
        </div>

        <div class="build-file-video-container product-video-container">
          <video class="build-file-video product-video"
                 :ref="videoList[7].ref"
                 :src="videoList[7].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>
      </div>

      <div class="selection-magnetic">
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>Cordless freedom</h5>
            <h5>with magnetic docking</h5>
          </div>
        </div>
        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">The handpiece and base are cordless and connected with Bluetooth® technology.</p>
          <p class="txt">Magnetic docking easily connects the handpiece base to the main unit for</p>
          <p class="txt">convenient handling with wirelss recharging.</p>
        </div>
        <div class="section-product-desc">
          <div class="magnetic-video-container product-video-container">

            <div class="progress">
              <circular-progress :progress="videoList[8].progress" :isPlaying="videoList[8].playing" index="8" @togglePlay="togglePlay"/>
            </div>
            <video class="magnetic-video product-video"
                   :ref="videoList[8].ref"
                   :src="videoList[8].video"
                   muted
                   playsinline
                   loop
            ></video>
          </div>
        </div>
      </div>

      <div class="section-touch-screen">
        <div class="touch-screen-list">
          <div class="touch-screen-item">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <h5>6-inch HD</h5>
                <h5>touchscreen</h5>
              </div>
            </div>
            <div class="image">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/f055b846712d32b00ca5269fa5fa8cef.png" alt=""/>
            </div>
          </div>
          <div class="touch-screen-item">
            <div class="product-special-title">
              <div class="product-detail-text1">
                <p class="txt">High-resolution display remains visible even under surgical lighting</p>
                <p class="txt">Responsive touchscreen compatible with gloved hands</p>
                <p class="txt">Quick preset interface for faster and more efficient workflows</p>
              </div>
            </div>
            <div class="image">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/bc98871ecd2c3c870d358a7ff2f71fd5.png" alt=""/>
            </div>
          </div>

        </div>

        <div class="section-packaging">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <h5>Packaging that lightens</h5>
              <h5>the planet’s load</h5>
            </div>
          </div>
          <div class="product-detail-text1"  style="text-align: center;">
            <p class="txt">Our commitment to the Earth starts with what we leave behind. By replacing plastics</p>
            <p class="txt">with high-standard biodegradable materials, we’ve created packaging that provides</p>
            <p class="txt">uncompromising protection for your device today—while ensuring it gracefully</p>
            <p class="txt">returns to nature tomorrow.</p>
            <p class="txt">A gift to the Earth, starting with packaging designed to disappear.</p>
          </div>

          <div class="image">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/69f6de3ab94b8a658f9cfe0bff2a6bc6.jpg" alt=""></img>
          </div>
        </div>

        <div class="keep-exploring">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <h5>Keep exploring Endo TG Series</h5>
            </div>
          </div>
          <div class="keep-exploring-container">
            <div class="mode-list">
              <div class="mode-item">
                <div class="mode-item-box">
                  <div class="image">
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>
                  </div>
                  <h5 class="title txt-center">Endo GT mini</h5>
                </div>
                <p class="txt txt-center">-</p>
                <p class="txt txt-center">-</p>
                <p class="txt txt-center">-</p>
              </div>
              <div class="mode-item">
                <div class="mode-item-box">
                  <div class="image">
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>
                  </div>
                  <h5 class="title txt-center">Endo GT</h5>
                </div>
                <p class="txt">Built-in AL in handpiece</p>
                <p class="txt txt-center">-</p>
                <p class="txt txt-center">-</p>
              </div>
              <div class="mode-item">
                <div class="mode-item-box">
                  <div class="image">
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>
                  </div>
                  <h5 class="title txt-center">Endo GT Pro</h5>
                </div>
                <p class="txt">Built-in AL in handpiece</p>
                <p class="txt">Built-in AL in main unit</p>
                <p class="txt">Wireless foot pedal</p>
              </div>
            </div>
            <i class="line"></i>

            <div class="mode-function mode-list">
              <div class="mode-function-item mode-item">
                <h5 class="title">Endo GT Mini</h5>
                <p class="txt">Contra-angle * 2</p>
                <p class="txt small">(one with LED / another one smaller without LED)</p>
                <p class="txt mt-4">Handpiece * 1</p>
                <p class="txt">Main unit * 1</p>
                <p class="txt">-</p>
                <p class="txt">Power adapter * 1</p>
                <p class="txt">-</p>
                <p class="txt">-</p>
                <p class="txt">-</p>
                <p class="txt">Charging base * 1</p>
                <p class="txt">-</p>
                <p class="txt">-</p>
                <p class="txt">Spray nozzle * 1</p>
                <p class="txt">Disposable sleeve * 10</p>
                <p class="txt">-</p>
                <p class="txt">Instructions for use * 1</p>
                <p class="txt">Packing list * 1</p>
              </div>
              <div class="mode-function-item mode-item">
                <h5 class="title">Endo GT</h5>
                <p class="txt">Contra-angle * 2</p>
                <p class="txt small">(one with LED / another one smaller without LED)</p>
                <p class="txt mt-4">Handpiece * 1</p>
                <p class="txt">Main unit * 1</p>
                <p class="txt">-</p>
                <p class="txt">Power adapter * 1</p>
                <p class="txt">File clip * 4</p>
                <p class="txt">Lip hook * 5</p>
                <p class="txt">Touch probe * 2</p>
                <p class="txt">Charging base * 1</p>
                <p class="txt">Measuring cable * 1</p>
                <p class="txt">Tester * 1</p>
                <p class="txt">Spray nozzle * 1</p>
                <p class="txt">Disposable sleeve * 10</p>
                <p class="txt">Protective silicone cover * 2</p>
                <p class="txt">Instructions for use * 1</p>
                <p class="txt">Packing list * 1</p>
              </div>
              <div class="mode-function-item mode-item">
                <h5 class="title">Endo GT Pro</h5>
                <p class="txt">Contra-angle * 2</p>
                <p class="txt small">(one with LED / another one smaller without LED)</p>
                <p class="txt mt-4">Handpiece * 1</p>
                <p class="txt">Main unit * 1</p>
                <p class="txt">Wireless foot pedal * 1</p>
                <p class="txt">Power adapter * 2</p>
                <p class="txt">File clip * 4</p>
                <p class="txt">Lip hook * 5</p>
                <p class="txt">Touch probe * 2</p>
                <p class="txt">Charging base * 1</p>
                <p class="txt">Measuring cable * 1</p>
                <p class="txt">Tester * 1</p>
                <p class="txt">Spray nozzle * 1</p>
                <p class="txt">Disposable sleeve * 10</p>
                <p class="txt">Protective silicone cover * 2</p>
                <p class="txt">Instructions for use * 1</p>
                <p class="txt">Packing list * 1</p>
              </div>
            </div>
            <i class="line" style="margin-top: 53px;"></i>

            <div class="specifications-container">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>Specifications</h5>
                </div>
              </div>

              <div class="specifications-list ">
                <div class="specifications-item">
                  <p class="txt">Speed</p>
                  <p class="title">50-3000 rpm</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">Torque</p>
                  <p class="title">0.4-5.0 N·cm</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">Ratio of contra-angle</p>
                  <p class="title">6:1</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">Integrated LED</p>
                  <p class="title">≥8000 lux</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">Working modes</p>
                  <p class="title">EAL, CW, CCW, REC (SGP), TorqueSense</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <video-modal ref="videoModalRef"></video-modal>
    </div>

  </div>
</template>

<script>


import circularProgress from "./components/progress-circle.vue";
import endoButton from './components/button.vue'
import videoModal from './components/video-modal.vue'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
//
export default {
  components: {
    circularProgress,
    endoButton,
    videoModal
  },
  data() {
    return {
      is_mounted: false,
      productc_nav: false,
      videoProgress: 0,
      videoIsPlaying: true,
      contraAngleSliderValue: 0,
      videoList: [
        {
          ref: 'previewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/796e824f5145403708972671759/oOkSHUvpaWoA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5b5a06b85145403713209442445/sIPEE86eV5IA.mp4',
        },
        {
          ref: 'productVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/473fa3e65145403709194452288/1J1BHLRNKowA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/56a834465145403714488171756/x2huXQ5iuEgA.mp4'
        },
        {
          ref: 'stepVideo1Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
        },
        {
          ref: 'stepVideo2Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
        },
        {
          ref: 'stepVideo3Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/cbbea11d5145403713214694823/WqHRUq4qiicA.mp4'
        },
        {
          ref: 'gPreviewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/7e22f7285145403709306548865/CUggH2zVoPcA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/58c945285145403714488245774/kUesAPotdfcA.mp4'
        },
        {
          ref: 'gModeVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/a960dc375145403713224008980/hruOoezPeoUA.mp4'
        },
        {
          ref: 'buildFileVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fee05aaa5145403715045789494/DIyA9cfuckQA.mp4'
        },
        {
          ref: 'magneticRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/36843a685145403714294898054/bbSFtNG3RrwA.mp4'
        },
      ],
      // videoList:[
      //   {
      //     ref: 'previewVideoRef',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5b5a06b85145403713209442445/sIPEE86eV5IA.mp4'
      //   },
      //   {
      //     ref: 'productVideoRef',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/56a834465145403714488171756/x2huXQ5iuEgA.mp4'
      //   },
      //   {
      //     ref: 'stepVideo1Ref',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
      //   },
      //   {
      //     ref: 'stepVideo2Ref',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
      //   },
      //   {
      //     ref: 'stepVideo3Ref',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/cbbea11d5145403713214694823/WqHRUq4qiicA.mp4'
      //   },
      //   {
      //     ref: 'gPreviewVideoRef',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/58c945285145403714488245774/kUesAPotdfcA.mp4'
      //   },
      //   {
      //     ref: 'gModeVideoRef',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/a960dc375145403713224008980/hruOoezPeoUA.mp4'
      //   },
      //   {
      //     ref: 'buildFileVideoRef',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/779b315e5145403714295362624/Kp3aHVMcpkUA.mp4'
      //   },
      //   {
      //     ref: 'magneticRef',
      //     progress: 0,
      //     playing: true,
      //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/36843a685145403714294898054/bbSFtNG3RrwA.mp4'
      //   },
      // ],
      contraAngleBanner: [
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c6067e872b55e5d6acf177939ac5a0c8.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/b59ba70340db05e588244f83f18a0f8e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/493cc727e1a9b5e616f29a2211ac7104.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/9ead80eb13be4a13f0f3cdc42285c9ff.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/72ce736cd62207015f96a91f83752ce6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/649aa3dd9b0219be20c02dbb3ea41cb4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/040fbcef9345317e6d5f8b63634507eb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/8238944342b81f5b8134ce2b715286e7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6d2c31c66743625370ef787fb2ec1b27.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/de71d210ca45ff166b222da3732253a6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ab90e7a6d3975e0a29c92cf0b6a31417.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/0c819732e2b2468b7fca309e559f25d0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/16a6ce0e7b967e2f87251c7bad80659e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d280151d0cb8197d4aa42a787c454db4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ec6e696ef61b2e74fd5180921dd96b63.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/e6d25395da38d05f2d50bb58f900e4ec.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/a1956fe4da20f7f1e849500bc86a33c7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/da1db807c80ef7d3cda11b17dba77314.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/afc00c7d7b782b7d0d89a67fd164c570.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/7fb5b76f81a3d809d1228a704bc74b20.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/debef22e218b390390be149c6ff5d2a0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/cb6940cd8b4f2b756961b647d2ac8e88.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c68e77cb7327bb6b434b16d420a86eca.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6e13e064ac62342482f6871cf419acfb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/413f3dbb1a3eea85c927879f1b952ef9.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d73bc851d358422a7fa81b61e8c3e8db.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/5d117257f053179f6f41ae8d2f60dab5.jpg',
      ],
      positionNav: [
        {
          title: 'Home',
          path: '/pchome'
        },
        {
          title: 'Products',
          path: '/pcproduct'
        },
        {
          title: 'Endo GT Series',
          path: '/pc/special/endo'
        },
      ],
      moveStart: true,
      improvedBannerTop: 0,
      isImprovedContainerRef: false
    };
  },
  mounted() {
    let that = this
    this.$nextTick(() => {
      this.is_mounted = true

      this.addSliderHoverListener();
      document.addEventListener('scroll', this.handleScroll, false)

      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('scroll', this.handleScroll, false)
      })
    })
  },
  created() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.$router.push({ path: '/ph/special/endo', query: this.$route.query })
    }
  },
  methods: {
    addSliderHoverListener() {
      this.$nextTick(() => {
        // 获取滑块组件的按钮包装器元素
        const sliderButtonWrapper = document.querySelector('.el-slider__button-wrapper');

        if (sliderButtonWrapper) {
          // 监听鼠标悬停事件
          sliderButtonWrapper.addEventListener('mouseenter', this.onSliderMouseEnter);
          sliderButtonWrapper.addEventListener('mouseleave', this.onSliderMouseLeave);
          this.contraAngleBannerMove()
        }
      });
    },
    onSliderMouseEnter() {
      this.moveStart = false
    },

    onSliderMouseLeave() {
      this.moveStart = true
    },
    removeSliderHoverListener() {
      const sliderButtonWrapper = document.querySelector('.el-slider__button-wrapper');

      if (sliderButtonWrapper) {
        sliderButtonWrapper.removeEventListener('mouseenter', this.onSliderMouseEnter);
        sliderButtonWrapper.removeEventListener('mouseleave', this.onSliderMouseLeave);
      }
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
    listenMove(value){
      if(value < this.contraAngleBanner.length){
        this.$refs.contraAngleAnimationRef.src = this.contraAngleBanner[value]
      }
    },
    contraAngleBannerMove(){
      if(this.moveStart){
        if(this.contraAngleSliderValue >= (this.contraAngleBanner.length - 1)){
          this.contraAngleSliderValue = 0
        }
        this.contraAngleSliderValue++
      }
      setTimeout(() => {
        this.contraAngleBannerMove()
      }, 500)
    },
    togglePlay(index) {
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[this.videoList[index].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
      }else {
        this.$refs[this.videoList[index].ref].pause();
      }
    },
    onImageLoad(){
      this.initScrollAnimation();
    },
    onModeVideoLoaded(){
      // this.initImprovedBannerAnimation()
    },
    onImprovedBanner(){
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     this.initImprovedBannerAnimation()
      //   }, 3000)
      // })
      this.initImprovedBannerPosition()

    },
    initImprovedBannerPosition(){
      const imgElement = document.querySelector('.special-main .special-body .improved-container .improved-banner img');
      if (imgElement) {
        const height = imgElement.offsetHeight;
        let space = window.innerHeight - height
        let top = 0

        if(space < 0){
          top = Math.abs(space) - 1
          // if(top > 310){
          //   top = 310
          // }
        }
        this.improvedBannerTop = top
      }
    },
    initImprovedBannerAnimation(){
      gsap.timeline({
        scrollTrigger: {
          trigger: ".improved-container",
          start: `top top`,
          end: `+=1000`,
          scrub: true,
          pin: true,
          onEnter: () => {
          },
        }
      }).to('.improved-banner-text', {
        opacity: 0
      })
          .to('.improved-background', {
            opacity: 1,
          }, '<')
          .to('.improved-content',{
            y: `-100vh`
          }, '<')
    },
    initScrollAnimation(){
      const _this = this

      const bannerElement = document.querySelector('.banner')

      this.videoList.forEach(item => {
        if(this.$refs[item.ref]){
          this.$refs[item.ref].addEventListener('timeupdate', this.onVideoProgress);
        }
      })
      this.setupVideoIntersectionObserver()

      gsap.timeline({
        scrollTrigger: {
          trigger: ".banner-container",
          start: `top top`,
          end: `+=2000`,
          scrub: true,
          pin: true,
          onEnter: () => {
            if (this.$refs[this.videoList[0].ref]) {
              this.$refs[this.videoList[0].ref].currentTime = 0;
              this.videoList[0].playing = true
              this.$refs[this.videoList[0].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
            }
          },
        }
      }).to(this.$refs.previewVideoContainerRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoTextRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoBoxRef, {
        background: 'rgba(0, 0, 0, 0)'
      }, "<")
    },
    setupVideoIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && !this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].play().catch(() => {});
              this.videoList[index].playing = true;
            }
          }else {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].pause();
              this.$refs[this.videoList[index].ref].currentTime = 0
              this.videoList[index].playing = false;
            }
          }
          // if (entry.intersectionRatio === 0) {
          //   this.videoList.forEach(item => {
          //     if (this.$refs[item.ref] === entry.target) {
          //       this.$refs[item.ref].pause();
          //       this.$refs[item.ref].currentTime = 0;
          //       item.playing = false;
          //     }
          //   });
          // } else if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
          //   this.videoList.forEach(item => {
          //     if (this.$refs[item.ref] === entry.target) {
          //       this.$refs[item.ref].play().catch(e => console.log(item.ref + "视频播放失败:", e));
          //       item.playing = true;
          //     }
          //   });
          // }
          if(this.$refs.improvedContainerRef == entry.target && entry.intersectionRatio >= 0.1 && !this.isImprovedContainerRef){
            this.isImprovedContainerRef = true
            this.initImprovedBannerAnimation()
          }
        });
      }, {
        threshold: [0, 0.1, 0.5, 1.0],
        rootMargin: '0px'
      });

      this.videoList.forEach(item => {
        if (this.$refs[item.ref]) {
          observer.observe(this.$refs[item.ref]);
        }
      });
      observer.observe(this.$refs.improvedContainerRef);

      this.$once('hook:beforeDestroy', () => {
        observer.unobserve(this.$refs.improvedContainerRef);
        this.videoList.forEach(item => {
          if (this.$refs[item.ref]) {
            observer.unobserve(this.$refs[item.ref]);
          }
        });
      });
    },
    onVideoProgress(event) {
      const video = event.target;
      const currentTime = video.currentTime;
      const duration = video.duration;

      const videoIndex = this.videoList.findIndex(item => {
        return this.$refs[item.ref] === video;
      });

      if (videoIndex !== -1) {
        this.videoList[videoIndex].progress = ((currentTime / duration) * 100).toFixed(2);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        this.productc_nav = true
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    ChangeEmit(){
      this.$refs.is_change.get_index_channel_data();
      this.$refs.is_change.pageParam();
    },
  },
  beforeDestroy() {
    this.removeSliderHoverListener();
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
};
</script>

<style >
h1, h2, h3, h4, h5, h6, p {
  padding: 0;
  margin: 0;
}

.pcdetails h1, .pcdetails h2, .pcdetails h3 {
  font-family: 'OPPOSans-H', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}

.pcdetails h4, .pcdetails h5 {
  font-family: 'OPPOSans-H', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}
.pcdetails p {
  font-family: 'OPPOSans-M', sans-serif;
  font-size: 20px;
  color: #7d7d7d ;
  margin: 0;
  padding: 0;
}

.pcdetails{
  width: calc(100vw);
  height: calc(100vh);
  /* overflow-x: hidden; */
  position: relative;
  background: #FAFAFA;
}
.pchome-headerabo{
  width: 100vw;
  position: relative;
  background-size: 100% 100%;
  padding-top: 79px;
  box-sizing: border-box;
}


.product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 20%,
  #ef5c11 60%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 60px;
  text-align: center;
  font-weight: 500;
  letter-spacing: -4px;
}

.product-special-title .product-special-title-b p {
  font-family: 'segoesc', sans-serif;
  text-align: center;
  color: #f45229;
  margin-top: 25px;
  font-size: 17.5px;
}

.product-detail-text1 {
  margin-top: 63px;
}

.product-detail-text1 .txt {
  color: #707070;
  font-size: 20px;
  line-height: 1.6;
  font-weight: bold;
}

.product-detail-text1 .button {
  margin: 62px auto 0 auto;
}

.product-detail-text2 {
  margin: 92px auto 0 auto;
  width: 990px;
}

.product-detail-text2 .txt {
  margin-top: 45px;
}

.product-detail-text2 .txt:first-child {
  margin-top: 0;
}

.special-main .special-body .banner-container {
  position: relative;
  height: 100vh;
}

.special-main .special-body .banner-container .banner {
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow: hidden;
}

.special-main .special-body .banner-container .banner img {
  width: 100%;
  display: block;
}

.special-main .special-body .banner-container .banner .banner-logo {
  width: 443px;
  margin: 85px auto 0 auto;
}
.special-main .special-body .banner-container .banner .banner-title {
  text-align: center;
  color: #696969;
  margin-top: 36px;
  font-size: 23px;
}
.special-main .special-body .banner-container .banner .banner-product {
  width: 800px;
  margin-top: -230px;
  margin-left: 520px;
}
.special-main .special-body .preview-video-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.special-main .special-body .preview-video-container .preview-video-box {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3;
}

.special-main .special-body .preview-video-container .preview-video-text {
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 4;
}

.special-main .special-body .preview-video-container .preview-video-text h4 {
  color: #ffffff;
  font-size: 36px;
  padding-top: 50px;
  text-align: center;
  font-weight: 500;
}

.special-main .special-body .preview-video-container .preview-video-text h4:first-child {
  padding-top: 220px;
}

.special-main .special-body .preview-video-container .preview-video-text .button {
  margin: 144px auto 0 auto;
}

.special-main .special-body .preview-video-container .progress {
  position: absolute;
  right: 40px;
  top: 20px;
  z-index: 5;
}

.special-main .special-body .preview-video-container .background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100vh;
  object-fit: cover;
  z-index: 1;
}

.special-main .special-body .section-product-desc {
  padding: 100px 0 150px 0;
  background: linear-gradient(#fefefe 0%, #f5f5f7 50%, #f5f5f7 100%);
}

.special-main .special-body .section-product-desc .product-logo {
  margin: 0 auto;
  width: 134px;
}

.special-main .special-body .section-product-desc .product-logo-text {
  margin: 32px auto 0 auto;
  width: 283px;
}

.special-main .special-body .section-product-desc .product-image {
  margin: 45px auto 0 auto;
  width: 100%;
}

.special-main .special-body .section-product-desc .step-list {
  width: 980px;
  margin: 47px auto 0 auto;
}

.special-main .special-body .section-product-desc .step-list .step-item {
  width: 980px;
  height: 319px;
  position: relative;
  overflow: hidden;
  border-radius: 30px;
  margin-top: 22px;
}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt {
  position: absolute;
  left: 80px;
  top: 75px;
}
.txt-big {}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title {
  display: flex;
  position: relative;
  width: 93px;
}
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title h5,
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title img {
  display: block;
  width: 93px;
}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title h5 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-big {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ef5c11 30%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 50px;
  font-weight: bold;
  margin-left: 5px;
}
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-middle {
  font-size: 40px;
}
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-small{
  font-size: 20px;
  font-weight: bold;
}

.special-main .special-body .section-product-desc .step-list .step-item:first-child {
  margin-top: 0;
}

.special-main .special-body .section-product-desc .step-list .step-item video {
  width: 990px;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
}

.special-main .special-body .section-product-desc .product-video-container {
  position: relative;
  width: 1250px;
  border-radius: 30px;
  overflow: hidden;
  margin: 24px auto 0 auto;
}

.special-main .special-body .section-product-desc .product-video-container .product-video {
  width: 100%;
  display: block;
}

.special-main .special-body .section-product-desc .product-video-container .progress {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 5;
}

.special-main .special-body .section-product-desc img {
  display: block;
  width: 100%;
}

.special-main .special-body .section-product-suit {
  background: #ffffff;
  padding-bottom: 400px;
}

.special-main .special-body .section-product-suit .product-logo {
  width: 234px;
}

.special-main .special-body .section-product-suit .product-logo-text {
  width: 270px;
  margin-top: -30px;
}

.special-main .special-body .section-product-suit .product-special-title {
  margin-top: 60px;
}

.special-main .special-body .section-product-suit .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 30%,
  #ef5c11 60%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.special-main .special-body .section-product-suit .product-special-title .product-special-title-b p {
  margin-top: 7px;
}

.special-main .special-body .section-product-suit .g-preview-video-container {
}

.special-main .special-body .section-product-suit .product-detail-text1 {
  margin-top: 65px;
}

.special-main .special-body .section-product-suit .product-detail-text1 .txt {
  margin-top: 0;
}

.special-main .special-body .section-product-suit .product-detail-text1 .txt:first-child {
  //margin-top: 159px;
}

.special-main .special-body .section-product-suit .product-detail-text3 {
  margin-top: 160px;
  width: 950px;
}

.special-main .special-body .section-product-suit .g-mode-video-container {
  width: 100%;
  margin-top: 35px;
}

.special-main .special-body .improved-container {
  width: 100%;
  height: 100vh;
  position: relative;
  z-index: 1;
}

.special-main .special-body .improved-container .improved-banner {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #000000;
}


/*.special-main .special-body .improved-container .improved-banner .blur-after {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  pointer-events: none;
  backdrop-filter: blur(0px) brightness(100%);
}*/
.special-main .special-body .improved-container .improved-banner .improved-background {
  position: absolute;
  width: calc(100vw - 12.55px);
  height: 100vh;
  z-index: 2;
  left: 0;
  top: 0;
  backdrop-filter: blur(20px) brightness(.6) ;
  opacity: 0;
  pointer-events: none;
}

.special-main .special-body .improved-container .improved-banner .improved-banner-text {
  position: absolute;
  left: 1116px;
  top: 80px;
}

.special-main .special-body .improved-container .improved-banner .improved-banner-text .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #ef5c11 60%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  text-align: left;
}

.special-main .special-body .improved-container .improved-banner .improved-banner-text .product-special-title .product-special-title-p {
  margin-top: 35px;
}

.special-main .special-body .improved-container .improved-banner .improved-banner-text .product-special-title .product-special-title-p p {
  color: #ffffff;
  font-weight: bold!important;
  letter-spacing: 1px;
  font-size: 20px;
  line-height: 1.6;
}

.special-main .special-body .improved-container .improved-banner img {
  width: 100%;
  display: block;
  object-fit: cover;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: -265px;
}

.special-main .special-body .improved-container .improved-banner  .improved-banner-img {

}

.special-main .special-body .improved-container .improved-content {
  width: 100%;
  height: 100vh;
  position: relative;
  z-index: 2;
}

.special-main .special-body .improved-container .improved-content .improved-content-container{
  display: flex;
  flex-direction: column;
  padding: 205px 0 0 542px;
}

.special-main .special-body .improved-container .improved-content .improved-content-title-info {

}
.special-main .special-body .improved-container .improved-content .improved-content-title-info .product-special-title {
  margin-top: 0;
}

.special-main .special-body .improved-container .improved-content .improved-content-title-info .product-special-title .product-special-title-b h5 {
  font-size: 58px;
  font-weight: 500;
}

.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title{
  margin-top: 42px;
}
.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title .product-special-title-b h5 {
  font-size: 19px;
  font-weight: 500;
  letter-spacing: -1px;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 3%,
  #f66f23 10%,
  #f66f23 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title .product-special-title-p{
  margin-top: 7px;
}
.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title .product-special-title-p p {
  font-size: 19px;
  font-weight: 500;
  letter-spacing: 0px;
}


.special-main .special-body .improved-container .improved-content .product-special-title {
  margin-top: 80px;
}

.special-main .special-body .improved-container .improved-content .product-special-title .product-special-title-b h5 {
  font-size: 40px;
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 3%,
  #f4681d 20%,
  #f4681d 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.special-main .special-body .improved-container .improved-content .product-special-title  .product-special-title-p {
  margin-top: 60px;
}
.special-main .special-body .improved-container .improved-content .product-special-title  .product-special-title-p p {
  color: #ffffff;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 1.8;
}
.special-main .special-body .improved-container .improved-content img {
  display: block;
  width: 100%;
}
.special-main .special-body .improved-container .improved-content .torque-sense {
  margin-top: 212px;
  padding-right: 183px;
}

.special-main .special-body .improved-container .improved-content .torque-sense .torque-sense-logo,
.special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {
  width: 143px;
}

.special-main .special-body .improved-container .improved-content .torque-sense .torque-sense-logo {
  margin: 0 auto;
}
.special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {
  margin-left: 20px;
}

.special-main .special-body .improved-container .improved-content .atr-mode {
  margin-top: 212px;
  padding-left: 183px;
}
.special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {

}


.contra-angle-container {
  background-color: #000000;
  padding-bottom: 190px;
  position: relative;
  z-index: 2;
}

.contra-angle-container .contra-angle-banner {

}

.contra-angle-container .contra-angle-banner img {
  display: block;
  width: 100%;
}

.contra-angle-container .contra-angle-banner .contra-angle-box{
  position: relative;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title {
  position: absolute;
  left: 544px;
  top: 210px;
}

.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .bending-head {
  width: 145px;
  margin-bottom: 25px;
}

.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .bending-head img {
  display: block;
  width: 100%;
}

.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-b {
  display: flex;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-b h5 {
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 50%,
  #f6853f 90%,
  #f6853f 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-b h5:nth-child(2) {
  color: #b1b1b1;
  font-size: 60px;
  margin-left: 10px;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-p {
  margin-top: 41px;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-p p{
  color: #b1b1b1;
  font-size: 22px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text {
  padding-left: 544px;
}

.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .product-special-title-b h5 {
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 3%,
  #ef5c11 20%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}


.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter {
  margin-top: 20px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align:nth-child(2) {
  margin-left: 68px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-b h5 {
  font-size: 30px;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ef5c11 70%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  letter-spacing: 0px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p {
  margin-left: 7px;

}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p,
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p p {
  font-size: 20px;
  color: #ffffff;
}

.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p p {

}

.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc {
  margin-top: 33px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .p-color{
  color: #b1b1b1!important;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p:first-child {
  margin-top: 0;
}

.contra-angle-container .contra-angle-animation {
  background-color: #000000;
  padding-top: 41px;
}
.contra-angle-container .contra-angle-slider {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}
.contra-angle-container .contra-angle-slider .el-slider {
  width: 300px;
}
.contra-angle-container .contra-angle-slider i {
  display: block;
  width: 50px;
}

.contra-angle-container .contra-angle-slider .dark {
  margin-right: 19px;
}
.contra-angle-container .contra-angle-slider .light {
  margin-left: 19px;
}
.contra-angle-container .contra-angle-slider i img {
  display: block;
  width: 100%;
}
.contra-angle-container .contra-angle-slider .el-slider__bar,
.contra-angle-container .contra-angle-slider .el-slider__runway {
  height: 12px;
  border-radius:50px;
}
.contra-angle-container .contra-angle-slider .el-slider__bar {
  background-color: #6c5dd3;
}
.contra-angle-container .contra-angle-slider .el-slider__button {
  position: absolute;
  top:50%;
  left: 50%;
  margin-top: -13px;
  margin-left: -13px;
  background-color: #6c5dd3;
  border: 0;
  width: 30px;
  height: 30px;
}
.contra-angle-animation .contra-angle-animation-container {
  width: 834px;
  margin: 30px auto 0 auto;
}
.contra-angle-animation .contra-angle-animation-container img {
  display: block;
  width: 100%;
}


.section-build-file {
  padding-top: 120px;
}
.section-build-file .product-special-title {}
.section-build-file .product-special-title .product-special-title-b {}
.section-build-file .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 40%,
  #ef5c11 50%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
.section-build-file .product-special-title .product-special-title-b p {
  margin-top: 11px;
}
.section-build-file .build-file-video-container {}
.section-build-file .build-file-video-container .build-file-video {
  display: block;
  //width: 1000px;
  margin:  40px auto 0 auto;
}
.section-build-file .product-detail-text1 {
  margin-top: 53px;
}
.selection-magnetic {
  background-color: #fefefe;
  padding-top: 100px;
}

.selection-magnetic .magnetic-video {
  width: 1252px!important;
}

.selection-magnetic .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 30%,
  #ef5c11 50%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}


.section-touch-screen {
  padding-top: 205px;
  background: linear-gradient(#fefefe 0%, #f5f5f7 50%, #f5f5f7 100%);
}
.section-touch-screen .touch-screen-list {
  display: flex;
  justify-content: center;
  align-items: center;
}
.section-touch-screen .touch-screen-list .touch-screen-item:nth-child(even) {
  margin-left: 53px;
}

.section-touch-screen .touch-screen-list .touch-screen-item .product-special-title {
  padding-bottom: 81px;
  display: flex;
  justify-content: right;
}
.section-touch-screen .touch-screen-list .touch-screen-item .product-special-title .product-special-title-b {
  margin-right: 68px;
}
.section-touch-screen .touch-screen-list .touch-screen-item .product-special-title-b h5{
  text-align: left;
}
.section-touch-screen .touch-screen-list .touch-screen-item .product-detail-text1 {
  padding-left: 10px;
}
.section-touch-screen .touch-screen-list .touch-screen-item .image {
  width: 712px;
}
.section-touch-screen .touch-screen-list .touch-screen-item .image img {
  display: block;
  width: 100%;
}

.special-main .section-packaging {
  margin-top: 160px;
}

.special-main .section-packaging .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #39ed54 0%,
  #39ed54 40%,
  #0db60c 70%,
  #0db60c 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 65px;
  font-weight: 500;
}

.special-main .section-packaging .product-detail-text1 {
  margin-top: 40px;
}
.special-main .section-packaging .product-detail-text1 .txt:last-child {
  margin-top: 30px;
}
.special-main .section-packaging .image {
  width: 1475px;
  margin: 50px auto 0 auto;
}
.special-main .section-packaging .image img {
  display: block;
  width: 100%;
  border-radius: 30px;
}


.section-touch-screen .keep-exploring {
  width: 1250px;
  margin: 200px auto 0 auto;
  padding-bottom: 166px;
}
.section-touch-screen .keep-exploring .keep-exploring-container {
  background-color: #ffffff;
  padding: 80px 180px 62px;
  margin-top: 42px;
  border-radius: 30px;
}
.section-touch-screen .keep-exploring .keep-exploring-container .line {
  display: block;
  border-top: #e7e7e9 1px solid;
  width: 100%;
  margin-top: 94px;
}
.section-touch-screen .keep-exploring .product-special-title .product-special-title-b h5 {
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ec540a 43%,
  #ec540a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 46px;
  font-weight: 500;
}
.section-touch-screen .keep-exploring .mode-list {
  display: flex;
  justify-content: center;

}
.section-touch-screen .keep-exploring .mode-list .mode-item {
  width: 250px;
  margin-left: 72px;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .mode-item-box {
  padding-right: 45px;
}
.section-touch-screen .keep-exploring .mode-list .mode-item:first-child {
  margin-left: 0;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .image {
  width: 152px;
  margin: 0 auto;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .image img {
  display: block;
  width: 100%;
}
.section-touch-screen .keep-exploring .mode-list .mode-item {

}
.section-touch-screen .keep-exploring .mode-list .mode-item .title {
  font-size: 20px;
  margin-top: 60px;
  color: #0f0f0f;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .txt {
  font-size: 17px;
  margin-top: 17px;
  color: #2a2a2a;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .txt:first-child {
  margin-top: 0;
}

.section-touch-screen .keep-exploring .mode-function {}
.section-touch-screen .keep-exploring .mode-function .mode-function-item {}
.section-touch-screen .keep-exploring .mode-function .mode-function-item .title {
  font-weight: 500;
}
.section-touch-screen .keep-exploring .mode-function .mode-function-item .small {
  font-size: 10px;
}

.section-touch-screen .keep-exploring .specifications-container {
  margin-top: 74px;
}
.section-touch-screen .keep-exploring .specifications-container .product-special-title {}
.section-touch-screen .keep-exploring .specifications-container .product-special-title .product-special-title-b {}
.section-touch-screen .keep-exploring .specifications-container .product-special-title .product-special-title-b h5 {
  font-size: 28px;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #eb5108 16%,
  #eb5108 100%);
  -webkit-background-clip: text;
  background-clip: text;
  letter-spacing: -1px;
}

.section-touch-screen .keep-exploring .specifications-container .specifications-list {}
.section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item {
  margin-top: 30px;
  display: flex;
}
.section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .title {
  font-size: 16px;
  color: #131313;
  margin-top: 0;
  line-height: 1.6;
}
.section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .txt {
  color: #6f6f74;
  font-size: 16px;
  line-height: 1.6;
  width: 321px;
}

.section-bottom-banner {
}
.section-bottom-banner img {
  display: block;
  width: 100%;
}
</style>
